module.exports = __webpack_public_path__ + "static/media/swaraj_843.2de107ef.png";